import { render, staticRenderFns } from "./DialPad.vue?vue&type=template&id=adc20e84&"
import script from "./DialPad.vue?vue&type=script&lang=js&"
export * from "./DialPad.vue?vue&type=script&lang=js&"
import style0 from "./DialPad.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports